import Reveal from "@/components/7fcc/Reveal";
import VideoTestimonials from "@/components/7fcc/VideoTestimonials";
import { VIDEO_TESTIMONIALS_CAPTION } from "@/data/content";

// Compact section for vertical video testimonials — phone-style frames,
// 4 across on desktop, 2x2 on tablet/mobile. Same blue/silver framing
// as the rest of the page. Metadata-only preload, native controls.
export default function VideoWinsSection() {
  return (
    <section className="bg-ink-900 px-6 py-16 md:py-24" data-testid="video-wins-section">
      <div className="mx-auto max-w-5xl">
        <Reveal>
          <p
            className="flex items-center justify-center gap-3 text-[11px] font-semibold uppercase tracking-[0.3em] text-brand-light"
            data-testid="video-wins-eyebrow"
          >
            <span className="h-px w-6 bg-brand/60" aria-hidden="true" />
            Wins In Their Own Words
            <span className="h-px w-6 bg-brand/60" aria-hidden="true" />
          </p>
        </Reveal>

        <div className="mt-8 md:mt-10">
          <VideoTestimonials testIdPrefix="video-testimonial" />
        </div>

        <Reveal delay={0.12}>
          <p
            className="mt-8 text-center text-sm leading-relaxed text-fg-muted md:mt-10"
            data-testid="video-wins-caption"
          >
            {VIDEO_TESTIMONIALS_CAPTION}
          </p>
        </Reveal>
      </div>
    </section>
  );
}
